import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import Dispatcher from './dispatcher';
import selector from './selector';

const useI18n = () => {
    const dispatcher = new Dispatcher(useDispatch());
    const state = useSelector(selector, shallowEqual);

    return [translator(state), dispatcher, state.lang];
}


function translator(state) {
    return {
        lang: state.lang,
        tag: (tag) => state.texts[tag]
    }
}

export default useI18n;